import { render, staticRenderFns } from "./c_home_seckill.vue?vue&type=template&id=3cd16464&scoped=true"
import script from "./c_home_seckill.vue?vue&type=script&lang=js"
export * from "./c_home_seckill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd16464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd16464')) {
      api.createRecord('3cd16464', component.options)
    } else {
      api.reload('3cd16464', component.options)
    }
    module.hot.accept("./c_home_seckill.vue?vue&type=template&id=3cd16464&scoped=true", function () {
      api.rerender('3cd16464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_seckill.vue"
export default component.exports